<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button>
				<a-button icon="sync" @click="apiDevicetypeList">刷新</a-button>
			</div>
		</div>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="devicetypeId"
				:loading="tableLoading" :pagination="false">
				<span slot="devicetypeName" slot-scope="devicetypeName">
					<a-button type="link" @click="edit(devicetypeName)" >{{devicetypeName.devicetypeName}}</a-button>
				</span>
		
				<span slot="devicetypeState" slot-scope="devicetypeState">
					<span v-if="devicetypeState == 2">禁用</span>
					<span v-if="devicetypeState == 3">启用</span>
				</span>
		
			</a-table>
		</div>

		<!-- 添加弹窗 -->
		<a-modal title="添加" width="600px" :visible="addVisible" :confirm-loading="addConfirmLoading" @ok="addHandleOk" @cancel="addHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="addRuleForm" :model="addForm" :label-col="{span: 6}" :wrapper-col="{span: 12}" :rules="addRules">
				<a-form-model-item label="设备类型名称" has-feedback prop="devicetypeName">
					<a-input v-model="addForm.devicetypeName" />
				</a-form-model-item>
				<a-form-model-item label="设备类型型号" has-feedback prop="devicetypeModel">
					<a-input v-model="addForm.devicetypeModel" />
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="devicetypeState">
					<a-radio-group name="devicetypeState" v-model="addForm.devicetypeState">
					    <a-radio :value="3">启用</a-radio>
						<a-radio :value="2">禁用</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="addForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
		<!-- 修改弹窗 -->
		<a-modal title="修改" width="600px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editHandleCancel" :maskClosable="false" :keyboard="false">
			<a-form-model ref="editRuleForm" :model="editForm" :label-col="{span: 6}" :wrapper-col="{span: 12}" :rules="addRules">
				<a-form-model-item label="设备类型名称" has-feedback prop="devicetypeName">
					<a-input v-model="editForm.devicetypeName" />
				</a-form-model-item>
				<a-form-model-item label="设备类型型号" has-feedback prop="devicetypeModel">
					<a-input v-model="editForm.devicetypeModel" />
				</a-form-model-item>
				<a-form-model-item label="状态" has-feedback prop="devicetypeState">
					<a-radio-group name="devicetypeState" v-model="editForm.devicetypeState">
					    <a-radio :value="3">启用</a-radio>
						<a-radio :value="2">禁用</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="备注" has-feedback prop="remarks">
					<a-textarea placeholder="在这里输入备注" :rows="4" v-model="editForm.remarks" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
			
				tableData: [],
				tableColumns: [{
						title: '设备类型ID',
						dataIndex: 'devicetypeId',
						key: 'devicetypeId',
						align: 'center'
					},
					{
						title: '设备类型名称',
						key: 'devicetypeName',
						align: 'center',
						scopedSlots: {
							customRender: 'devicetypeName'
						}
					},
					{
						title: '状态',
						dataIndex: 'devicetypeState',
						key: 'devicetypeState',
						align: 'center',
						scopedSlots: {
							customRender: 'devicetypeState'
						}
					},
					{
						title: '备注',
						dataIndex: 'remarks',
						key: 'remarks',
						align: 'center',
					},

				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addVisible: false,
				addConfirmLoading: false,
				addForm: {
					devicetypeName: '',
					devicetypeModel: '',
					devicetypeState: 3,
					remarks: '',
				},
				addRules: {
					devicetypeName: [{ required: true, message: '设备类型名称不能为空', trigger: 'blur' }],
					devicetypeState: [{ required: true, message: '请选择状态', trigger: 'blur' }],
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					devicetypeId: '',
					devicetypeName: '',
					devicetypeModel: '',
					devicetypeState: 3,
					remarks: '',
				},
				// 修改弹窗-end
			};
		},
		methods: {
			async apiDevicetypeList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDevicetypeList);
				if (res.code == 200) {
					this.tableData = res.data
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
		
			//添加弹窗事件-开始
			async apiDevicetypeAdd() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDevicetypeAdd, this.addForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.addRuleForm.resetFields();
					this.apiDevicetypeList()
					this.addConfirmLoading = false
					this.addVisible = false
				} else {
					this.$message.error(res.msg)
					this.addConfirmLoading = false
				}
			},
			
			addHandleOk() {
				this.$refs.addRuleForm.validate(valid => {
					if (valid) {
						this.apiDevicetypeAdd()
					} else {
					  return false;
					  this.addConfirmLoading = true
					}
				});
				
			},
			addHandleCancel() {
				this.addVisible = false
			},
			//添加弹窗事件-结束
			//修改弹窗事件-开始
			edit(item){
				this.editForm = item
				this.editVisible = true
			},
			async apiDevicetypeEdit() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDevicetypeEdit, this.editForm);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiDevicetypeList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiDevicetypeEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			editHandleCancel() {
				this.editVisible = false
			},
			//修改弹窗事件-结束
			
			//删除
			tableDel() {
				let that = this
				if(this.tableSelectedRows.devicetypeId > 0) {
					this.$confirm({
						title: '确定要删除当前选中数据吗',
						content: this.tableSelectedRows.devicetypeName,
						okText: '确定',
						okType: 'danger',
						cancelText: '取消',
						onOk() {
							that.apiDevicetypeDel()
						},
						onCancel() {
						},
					});
				}else{
					this.$message.warning('请选择要删除的数据');
				}
			},
			//删除
			async apiDevicetypeDel() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiDevicetypeDel, {devicetypeId: this.tableSelectedRows.devicetypeId});
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.apiDevicetypeList()
				} else {
					this.$message.error(res.msg)
				}
			},
			tableEdit() {
				if(this.tableSelectedRows.devicetypeId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiDevicetypeList()
		}
	};
</script>

<style scoped>
	.main-info {
		background-color: #fff;
	}
	

</style>
